import { render } from "./BaseMods.vue?vue&type=template&id=278b1470&scoped=true&bindings={\"shared\":\"options\",\"isOpen\":\"props\",\"initialValues\":\"props\",\"debug\":\"setup\",\"inEditMode\":\"setup\",\"handleDidDismiss\":\"setup\",\"formInfo\":\"setup\",\"archiveOutline\":\"setup\",\"archiveSharp\":\"setup\",\"route\":\"setup\",\"router\":\"setup\",\"laListe\":\"setup\",\"jscmodeles\":\"setup\",\"add\":\"setup\"}"
import script from "./BaseMods.vue?vue&type=script&lang=js"
export * from "./BaseMods.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-278b1470"

export default script